import { useMemo } from "react"
import moment from "moment"
import { normalizeTimeOffByDay, dayKey } from "../utils"
import { useCalendarTimeOff } from "./useCalendarSelectors"

export const useTimeOffByDay = (calendarDays = []) => {
  const calendarTimeOff = useCalendarTimeOff()
  return useMemo(() => normalizeTimeOffByDay(calendarTimeOff || [], calendarDays), [calendarTimeOff, calendarDays])
}

export const useTimeOffForDate = (date) => {
  const calendarTimeOff = useCalendarTimeOff()
  return useMemo(() => {
    if (!date) return { allDay: false, ranges: [] }
    const m = moment(date)
    const map = normalizeTimeOffByDay(calendarTimeOff || [], [m])
    return map[dayKey(m)] || { allDay: false, ranges: [] }
  }, [calendarTimeOff, date])
}
